import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './global'
import './interception'
import formatNumberWithCommas from '@/utils/money'
import addressBook from '@/utils/submitContacts'
// import VConsole from 'vconsole'
// new VConsole({})
// import FastClick from 'fastclick'
// FastClick.attach(document.body)

Vue.config.productionTip = false
Vue.prototype.formatNumberWithCommas = formatNumberWithCommas
Vue.prototype.addressBook = addressBook

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
